"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_BUTTONS = exports.MARK_BUTTONS = exports.redo = exports.undo = exports.canRedo = exports.canUndo = exports.withCodeBlockBreaks = exports.resetBlockToPAtStart = exports.removeEmptyPrevP = exports.tryExitCodeBlockOnTripleEnter = exports.exitStepperList = exports.insertCodeBlockExit = exports.insertCodeBlockBreak = exports.isInRawTextBlock = exports.resetEmptyBlockToP = exports.setChecklistItemChecked = exports.eraseMarks = exports.setAlignment = exports.toggleBlock = exports.getCurrentBlockEntry = exports.isAlignmentActive = exports.getActiveAlignment = exports.isListActive = exports.isBlockActive = exports.getActiveBlock = exports.toggleMark = exports.isMarkActive = exports.MARKS = exports.ALIGNMENTS = exports.LIST_TYPES = exports.isListType = void 0;
const slate_1 = require("slate");
const slate_history_1 = require("slate-history");
const link_1 = require("./behavior/link");
const lists_1 = require("./behavior/lists");
Object.defineProperty(exports, "isListType", { enumerable: true, get: function () { return lists_1.isListType; } });
Object.defineProperty(exports, "LIST_TYPES", { enumerable: true, get: function () { return lists_1.LIST_TYPES; } });
exports.ALIGNMENTS = ['left', 'center', 'right', 'justify'];
exports.MARKS = [
    'bg',
    'bold',
    'code',
    'del',
    'fg',
    'ins',
    'italic',
    'kbd',
    'mark',
    'overline',
    'spoiler',
    'strikethrough',
    'sub',
    'sup',
    'underline',
];
const isElement = (node) => slate_1.Element.isElement(node);
const isFormattableBlock = (node) => !(0, lists_1.isListType)(node.type) && node.type !== 'embed';
const isMarkActive = (editor, format) => {
    const marks = slate_1.Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
exports.isMarkActive = isMarkActive;
const toggleMark = (editor, format) => {
    if ((0, exports.isMarkActive)(editor, format))
        slate_1.Editor.removeMark(editor, format);
    else
        slate_1.Editor.addMark(editor, format, true);
};
exports.toggleMark = toggleMark;
const getActiveBlock = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node),
    });
    return match?.[0] ?? null;
};
exports.getActiveBlock = getActiveBlock;
const isBlockActive = (editor, format) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === format,
    });
    return !!match;
};
exports.isBlockActive = isBlockActive;
const isAtEndOfBlock = (editor, format) => {
    const { selection } = editor;
    if (!selection || !slate_1.Range.isCollapsed(selection))
        return false;
    const match = slate_1.Editor.above(editor, {
        at: selection,
        match: (node) => isElement(node) && node.type === format,
        mode: 'lowest',
    });
    if (!match)
        return false;
    const [, path] = match;
    return slate_1.Editor.isEnd(editor, selection.anchor, path);
};
const isListActive = (editor, format) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === format,
    });
    return !!match;
};
exports.isListActive = isListActive;
const getActiveAlignment = (editor) => {
    const { selection } = editor;
    if (!selection)
        return 'left';
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
    if (!match)
        return 'left';
    const [element] = match;
    return element.align ?? 'left';
};
exports.getActiveAlignment = getActiveAlignment;
const isAlignmentActive = (editor, alignment) => (0, exports.getActiveAlignment)(editor) === alignment;
exports.isAlignmentActive = isAlignmentActive;
const unwrapLists = (editor) => {
    slate_1.Transforms.unwrapNodes(editor, {
        match: (node) => isElement(node) && (0, lists_1.isListType)(node.type),
        split: true,
    });
};
const getCurrentBlockEntry = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node),
        mode: 'lowest',
    });
    return match ?? null;
};
exports.getCurrentBlockEntry = getCurrentBlockEntry;
const getCurrentListType = (editor) => {
    const { selection } = editor;
    if (!selection)
        return null;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && (0, lists_1.isListType)(node.type),
        mode: 'lowest',
    });
    return match ? match[0].type : null;
};
const toggleBlock = (editor, format) => {
    const isList = (0, lists_1.isListType)(format);
    const isActive = isList ? (0, exports.isListActive)(editor, format) : (0, exports.isBlockActive)(editor, format);
    unwrapLists(editor);
    const nextType = isActive ? 'p' : isList ? 'li' : format;
    slate_1.Transforms.setNodes(editor, { type: nextType }, {
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
    if (!isActive && isList) {
        slate_1.Transforms.wrapNodes(editor, { type: format, children: [] }, {
            match: (node) => isElement(node) && node.type === 'li',
        });
    }
    if (format === 'checklist' && !isActive) {
        slate_1.Transforms.setNodes(editor, { checked: false }, {
            match: (node) => isElement(node) && node.type === 'li',
        });
    }
    else {
        slate_1.Transforms.unsetNodes(editor, 'checked', {
            match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && !(0, lists_1.isListType)(node.type),
        });
    }
};
exports.toggleBlock = toggleBlock;
const setAlignment = (editor, alignment) => {
    const current = (0, exports.getActiveAlignment)(editor);
    const shouldUnset = alignment === 'left' || current === alignment;
    if (shouldUnset) {
        slate_1.Transforms.unsetNodes(editor, 'align', {
            match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
        });
        return;
    }
    slate_1.Transforms.setNodes(editor, { align: alignment }, {
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
};
exports.setAlignment = setAlignment;
const eraseMarks = (editor) => {
    (0, link_1.removeLink)(editor);
    for (const mark of exports.MARKS)
        slate_1.Editor.removeMark(editor, mark);
};
exports.eraseMarks = eraseMarks;
const setChecklistItemChecked = (editor, path, checked) => {
    slate_1.Transforms.setNodes(editor, { checked }, {
        at: path,
        match: (node) => isElement(node) && node.type === 'li',
    });
};
exports.setChecklistItemChecked = setChecklistItemChecked;
const resetEmptyBlockToP = (editor) => {
    const { selection } = editor;
    if (!selection || !slate_1.Range.isCollapsed(selection))
        return false;
    const entry = (0, exports.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [block] = entry;
    if (block.type === 'embed')
        return false;
    if (slate_1.Node.string(block) !== '')
        return false;
    if (block.type === 'p')
        return false;
    if (block.type === 'li') {
        const listType = getCurrentListType(editor);
        if (!listType) {
            slate_1.Transforms.setNodes(editor, { type: 'p' }, {
                match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && node.type === 'li',
            });
            return true;
        }
        (0, exports.toggleBlock)(editor, listType);
        return true;
    }
    (0, exports.toggleBlock)(editor, block.type);
    return true;
};
exports.resetEmptyBlockToP = resetEmptyBlockToP;
const isInRawTextBlock = (editor) => (0, exports.isBlockActive)(editor, 'code-block') || (0, exports.isBlockActive)(editor, 'pre');
exports.isInRawTextBlock = isInRawTextBlock;
const insertCodeBlockBreak = (editor) => {
    if (!(0, exports.isInRawTextBlock)(editor))
        return false;
    slate_1.Editor.insertText(editor, '\n');
    return true;
};
exports.insertCodeBlockBreak = insertCodeBlockBreak;
const insertCodeBlockExit = (editor) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && (node.type === 'code-block' || node.type === 'pre'),
    });
    if (!match)
        return false;
    const [, path] = match;
    const afterPath = slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] }, { at: afterPath });
    slate_1.Transforms.select(editor, afterPath);
    return true;
};
exports.insertCodeBlockExit = insertCodeBlockExit;
/**
 * If the caret is anywhere inside a `stepper` list, drop a fresh paragraph
 * after the list and move the caret there — an explicit way to "exit" the
 * stepper without having to land on an empty step.
 */
const exitStepperList = (editor) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const match = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === 'stepper',
        mode: 'lowest',
    });
    if (!match)
        return false;
    const [, path] = match;
    const afterPath = slate_1.Path.next(path);
    slate_1.Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] }, { at: afterPath });
    slate_1.Transforms.select(editor, afterPath);
    return true;
};
exports.exitStepperList = exitStepperList;
const isInStepperLi = (editor) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const li = slate_1.Editor.above(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && node.type === 'li',
        mode: 'lowest',
    });
    if (!li)
        return false;
    const stepper = slate_1.Editor.above(editor, {
        at: li[1],
        match: (node) => isElement(node) && node.type === 'stepper',
        mode: 'lowest',
    });
    return !!stepper;
};
/**
 * If the caret is at the end of a code-block or pre block and the block's
 * text content already ends with `\n\n`, strip those trailing newlines and
 * exit the block into a new paragraph below.
 */
const tryExitCodeBlockOnTripleEnter = (editor) => {
    const { selection } = editor;
    if (!selection || !slate_1.Range.isCollapsed(selection))
        return false;
    const match = slate_1.Editor.above(editor, {
        at: selection,
        match: (node) => isElement(node) && (node.type === 'code-block' || node.type === 'pre'),
        mode: 'lowest',
    });
    if (!match)
        return false;
    const [block, path] = match;
    if (!slate_1.Editor.isEnd(editor, selection.anchor, path))
        return false;
    if (!slate_1.Node.string(block).endsWith('\n\n'))
        return false;
    slate_1.Transforms.delete(editor, { distance: 2, unit: 'character', reverse: true });
    return (0, exports.insertCodeBlockExit)(editor);
};
exports.tryExitCodeBlockOnTripleEnter = tryExitCodeBlockOnTripleEnter;
const HEADING_TYPES = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'title', 'subtitle']);
/**
 * If the caret is at offset 0 of a block whose previous sibling is an empty
 * `<p>`, remove that empty paragraph.
 */
const removeEmptyPrevP = (editor) => {
    const { selection } = editor;
    if (!selection || !slate_1.Range.isCollapsed(selection))
        return false;
    const entry = (0, exports.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [, path] = entry;
    if (!slate_1.Editor.isStart(editor, selection.anchor, path))
        return false;
    if (!slate_1.Path.hasPrevious(path))
        return false;
    const prevPath = slate_1.Path.previous(path);
    let prevNode;
    try {
        prevNode = slate_1.Node.get(editor, prevPath);
    }
    catch {
        return false;
    }
    if (!isElement(prevNode))
        return false;
    if (prevNode.type !== 'p')
        return false;
    if (slate_1.Node.string(prevNode) !== '')
        return false;
    slate_1.Transforms.removeNodes(editor, { at: prevPath });
    return true;
};
exports.removeEmptyPrevP = removeEmptyPrevP;
/**
 * Backspace at offset 0 of a non-empty heading, blockquote, callout, or list
 * item converts that block to a paragraph instead of merging with the
 * previous block. Empty blocks are handled by `resetEmptyBlockToP`.
 */
const resetBlockToPAtStart = (editor) => {
    const { selection } = editor;
    if (!selection || !slate_1.Range.isCollapsed(selection))
        return false;
    const entry = (0, exports.getCurrentBlockEntry)(editor);
    if (!entry)
        return false;
    const [block, path] = entry;
    if (slate_1.Node.string(block) === '')
        return false;
    if (!slate_1.Editor.isStart(editor, selection.anchor, path))
        return false;
    const isResettable = HEADING_TYPES.has(block.type) || block.type === 'blockquote' || block.type === 'callout' || block.type === 'li';
    if (!isResettable)
        return false;
    if (block.type === 'li') {
        const listType = getCurrentListType(editor);
        if (!listType) {
            slate_1.Transforms.setNodes(editor, { type: 'p' }, {
                match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && node.type === 'li',
            });
            return true;
        }
        (0, exports.toggleBlock)(editor, listType);
        return true;
    }
    (0, exports.toggleBlock)(editor, block.type);
    return true;
};
exports.resetBlockToPAtStart = resetBlockToPAtStart;
const withCodeBlockBreaks = (editor) => {
    const { insertBreak } = editor;
    editor.insertBreak = () => {
        if ((0, exports.tryExitCodeBlockOnTripleEnter)(editor))
            return;
        if ((0, exports.insertCodeBlockBreak)(editor))
            return;
        if ((0, exports.resetEmptyBlockToP)(editor))
            return;
        const activeBlock = (0, exports.getActiveBlock)(editor);
        const inHeading = activeBlock && HEADING_TYPES.has(activeBlock.type);
        const inHeadingOrBlockquoteOrCallout = activeBlock && ['blockquote', 'callout'].includes(activeBlock.type);
        const atEndOfTitle = isAtEndOfBlock(editor, 'title');
        const inStepperLi = isInStepperLi(editor);
        let convertPreviousSibling = false;
        if (inHeading || inHeadingOrBlockquoteOrCallout) {
            const entry = (0, exports.getCurrentBlockEntry)(editor);
            const sel = editor.selection;
            if (entry && sel && slate_1.Range.isCollapsed(sel)) {
                convertPreviousSibling = slate_1.Editor.isStart(editor, sel.anchor, entry[1]);
            }
        }
        const inCallout = activeBlock && activeBlock.type === 'callout';
        insertBreak();
        if (inHeading || inHeadingOrBlockquoteOrCallout) {
            const nextType = atEndOfTitle ? 'subtitle' : 'p';
            let targetPath;
            if (convertPreviousSibling) {
                const cursorEntry = (0, exports.getCurrentBlockEntry)(editor);
                if (cursorEntry && slate_1.Path.hasPrevious(cursorEntry[1])) {
                    targetPath = slate_1.Path.previous(cursorEntry[1]);
                    slate_1.Transforms.setNodes(editor, { type: nextType }, { at: targetPath });
                }
            }
            else {
                slate_1.Transforms.setNodes(editor, { type: nextType });
            }
            // Drop callout-specific attributes so the new <p> doesn't inherit them
            // when the user breaks out of a callout.
            if (inCallout) {
                const unsetOpts = targetPath ? { at: targetPath } : undefined;
                slate_1.Transforms.unsetNodes(editor, ['variant', 'icon', 'title', 'color'], unsetOpts);
            }
        }
        if (inStepperLi) {
            slate_1.Transforms.unsetNodes(editor, [
                'stepTitle',
                'stepDesc',
                'stepState',
                'stepIndicator',
                'stepChar',
                'stepCol',
                'stepBg',
                'ring',
                'ringCol',
                'ringWidth',
                'halo',
                'haloCol',
                'haloWidth',
                'line',
                'lineCol',
                'lineWidth',
            ], { match: (node) => isElement(node) && node.type === 'li' });
        }
    };
    // Inside a code-block or pre block, paste raw text.
    const reactEditor = editor;
    const { insertData } = reactEditor;
    if (insertData) {
        reactEditor.insertData = (data) => {
            if ((0, exports.isInRawTextBlock)(editor)) {
                const text = data.getData('text/plain');
                if (text) {
                    slate_1.Editor.insertText(editor, text);
                    return;
                }
            }
            insertData(data);
        };
    }
    return editor;
};
exports.withCodeBlockBreaks = withCodeBlockBreaks;
const canUndo = (editor) => slate_history_1.HistoryEditor.isHistoryEditor(editor) && editor.history.undos.length > 0;
exports.canUndo = canUndo;
const canRedo = (editor) => slate_history_1.HistoryEditor.isHistoryEditor(editor) && editor.history.redos.length > 0;
exports.canRedo = canRedo;
const undo = (editor) => {
    if (slate_history_1.HistoryEditor.isHistoryEditor(editor))
        editor.undo();
};
exports.undo = undo;
const redo = (editor) => {
    if (slate_history_1.HistoryEditor.isHistoryEditor(editor))
        editor.redo();
};
exports.redo = redo;
exports.MARK_BUTTONS = [
    { key: 'bold', title: 'Bold', iconSet: 'radix', icon: 'font-bold', shortcut: 'Cmd+B', format: 'bold' },
    { key: 'italic', title: 'Italic', iconSet: 'lucide', icon: 'italic', shortcut: 'Cmd+I', format: 'italic' },
    { key: 'underline', title: 'Underline', iconSet: 'tabler', icon: 'underline', shortcut: 'Cmd+U', format: 'underline' },
    { key: 'code', title: 'Inline code', iconSet: 'tabler', icon: 'code', shortcut: 'Cmd+E', format: 'code' },
];
exports.ACTION_BUTTONS = [
    { key: 'undo', title: 'Undo', iconSet: 'lucide', icon: 'undo', shortcut: 'Cmd+Z' },
    { key: 'redo', title: 'Redo', iconSet: 'lucide', icon: 'redo', shortcut: 'Cmd+Shift+Z' },
];
